<template>
  <div class="h-full">
    <el-card :body-style="{ height: '100%' }" class="h-full" v-show="!showPersonForm">
      <div class="h-full flex flex-col">
        <div class="overflow-y-auto overflow-x-hidden flex-auto">
          <div class="flex items-center h-32px" v-if="['update', 'approve'].includes(mode)">
            <p class="pl-10px border-l-3px text-18px border-color-primary">
              {{ titleType }}{{ $t('单位信息') }}
            </p>
          </div>
          <el-page-header
            v-else
            :content="`${titleType}${$t('单位信息')}`"
            @back="$router.go(-1)"
          ></el-page-header>
          <el-form
            ref="form"
            class="my-20px contractor-form"
            :model="form"
            :rules="rules"
            label-width="150px"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item :label="`${$t('承包商单位名称')}`" prop="name">
                  <el-input
                    v-model="form.name"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!updateMode && !canEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('承包商单位简称')}`" prop="abbreviation">
                  <el-input
                    v-model="form.abbreviation"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!updateMode && !canEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('在厂周期')}`" prop="period">
                  <el-date-picker
                    v-model="form.period"
                    type="daterange"
                    class="!w-full"
                    size="small"
                    range-separator="至"
                    :start-placeholder="`${$t('开始日期')}`"
                    :end-placeholder="`${$t('结束日期')}`"
                    :disabled="!canEdit"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('承包商单位负责人')}`" prop="leaderName">
                  <el-input
                    v-model="form.leaderName"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!canEdit"
                    @blur="validateLeaderAccount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('联系电话')}`" prop="phoneNumber">
                  <el-input
                    v-model="form.phoneNumber"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!canEdit"
                    @blur="validateLeaderAccount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('个人账号')}`" prop="leaderAccount">
                  <div slot="label" class="inline-block">
                    <el-tooltip
                      content="请联系相关专业主管,确认账号开通格式,否则将无法审批通过"
                      placement="top"
                      effect="dark"
                    >
                      <span class="iconfont icon-bg-circleInfo mr-5px"></span>
                    </el-tooltip>
                    <span>{{ $t('个人账号') }}</span>
                  </div>
                  <el-input
                    v-model="form.leaderAccount"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!canEdit || disabledAccount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('身份证号码')}`" prop="leaderIdCard">
                  <el-input
                    v-model="form.leaderIdCard"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!canEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('邮箱')}`" prop="email">
                  <el-input
                    v-model="form.email"
                    :placeholder="`${$t('请输入')}`"
                    :disabled="!canEdit"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所属专业" prop="ownerdSpecialtyId">
                  <el-select
                    v-model="form.ownerdSpecialtyId"
                    filterable
                    placeholder="请选择所属专业"
                    clearable
                    class="w-full"
                    :disabled="!updateMode && !canEdit"
                  >
                    <el-option
                      v-for="item in specialtyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="my-20px" v-if="![0, 2, 3].includes(form.approvalStatus)">
            <div class="flex items-center h-32px mb-10px">
              <p class="pl-10px border-l-3px text-18px border-color-primary">
                {{ titleType }}{{ $t('人员信息') }}
              </p>
            </div>
            <div class="flex flex-wrap">
              <el-input
                clearable
                v-model="search.name"
                class="w-200px mr-10px mb-10px"
                size="small"
                :maxlength="50"
                :placeholder="`${$t('人员姓名')}`"
              ></el-input>
              <el-button @click="searchList" size="small" type="primary">搜索</el-button>
              <el-button @click="reset" size="small">重置</el-button>
              <el-button
                size="small"
                type="primary"
                :disabled="disabledOperation"
                @click="operate('create')"
                >添加人员</el-button
              >
              <el-button
                size="small"
                type="danger"
                :disabled="disabledOperation"
                @click="batchDelete"
                >批量删除</el-button
              >
              <el-button size="small" :disabled="disabledOperation" @click="batchImoport"
                >导入</el-button
              >
              <el-button size="small" @click="exportPersonList">导出</el-button>
              <el-button
                size="small"
                type="primary"
                :disabled="disabledOperation"
                @click="openApprovalDialog('submit')"
                >一键提交</el-button
              >
              <el-button
                size="small"
                type="primary"
                :disabled="disabledOperation"
                @click="openApprovalDialog('approval')"
                >一键审批</el-button
              >
              <el-button @click="setBlack(true)" size="small" :disabled="disabledOperation"
                >加入黑名单</el-button
              >
              <el-button @click="setBlack(false)" size="small" :disabled="disabledOperation"
                >移除黑名单</el-button
              >
            </div>
            <el-table
              :data="tableData"
              stripe
              border
              ref="table"
              class="mt-10px"
              row-key="id"
              @selection-change="handleSelectionChange"
              v-loading="loading"
            >
              <el-table-column
                type="selection"
                width="60"
                align="center"
                :reserve-selection="true"
              ></el-table-column>
              <el-table-column
                prop="department"
                :label="`${$t('所属单位')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="name"
                :label="`${$t('姓名')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="phoneNumber"
                :label="`${$t('联系电话')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="projectName"
                :label="`${$t('关联项目')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="gender" :label="`${$t('性别')}`" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.gender === '1'">{{ $t('男') }}</span>
                  <span v-else-if="scope.row.gender === '0'">{{ $t('女') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="isTempWork"
                :label="`${$t('是否临时用工')}`"
                show-overflow-tooltip
              >
                <template slot-scope="scope">{{
                  scope.row.isTempWork ? $t('是') : $t('否')
                }}</template>
              </el-table-column>
              <el-table-column
                prop="employeeTypeStr"
                :label="`${$t('人员分类')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="postJobCategoryStr"
                :label="`${$t('职务工种')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="isSpecialJob"
                :label="`${$t('是否特种作业')}`"
                show-overflow-tooltip
              >
                <template slot-scope="scope">{{
                  scope.row.isSpecialJob ? $t('是') : $t('否')
                }}</template>
              </el-table-column>
              <el-table-column
                prop="jobCategoryStr"
                :label="`${$t('工种')}`"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="status" width="80" :label="`${$t('人员状态')}`">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
                    scope.row.statusStr
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="isBlacklist" width="100" :label="`${$t('是否黑名单')}`">
                <template slot-scope="scope">
                  <el-tag size="mini" type="danger" v-if="scope.row.isBlacklist === true"
                    >是</el-tag
                  >
                  <el-tag size="mini" type="success" v-else-if="scope.row.isBlacklist === false"
                    >否</el-tag
                  >
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column prop="approvalStatus" width="80" :label="`${$t('流程状态')}`">
                <template slot-scope="scope">
                  <el-tag size="mini" :type="workFlowStatusTypes(scope.row.approvalStatus)">{{
                    scope.row.approvalStatusStr
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="270px" fixed="right">
                <template slot-scope="scope">
                  <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20px text-right"
              background
              :current-page.sync="page.pageNo"
              @size-change="searchList"
              @current-change="findList"
              :page-sizes="[15, 30, 45, 60, 75, 90]"
              :page-size.sync="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <div
          class="text-center pt-20px border-t-1px border-color-default"
          v-if="['update', 'approve'].includes(mode)"
        >
          <el-button
            size="small"
            type="primary"
            @click="save('save')"
            :loading="formBtnLoading"
            v-if="mode === 'update'"
            >保存</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="save('submit')"
            :loading="formBtnLoading"
            v-if="
              ['update', 'approve'].includes(mode) &&
                ([0, 3].includes(form.approvalStatus) ||
                  ([2].includes(form.approvalStatus) && form.taskId))
            "
            >提交</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="approvalDialog = true"
            v-if="mode === 'approve' && !form.isBlackList && [1].includes(form.approvalStatus)"
            >{{ $t('审批') }}</el-button
          >
          <el-button size="small" @click="$router.go(-1)">{{ $t('取消') }}</el-button>
        </div>
      </div>
      <ApprovalFlowDialog
        :visible.sync="approvalFlowDialog"
        v-if="approvalFlowDialog"
        :id="flowTaskId"
        @cancel="approvalFlowDialog = false"
      >
      </ApprovalFlowDialog>
      <ApprovalDialog
        :visible.sync="approvalDialog"
        :loading="approvalLoading"
        @submit="submitApproval"
      />
    </el-card>
    <ShortTermContractorPerson
      v-if="showPersonForm"
      :formMode="formMode"
      :formId="formId"
      :formContractorId="form.id"
      @back="backToForm"
    />
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
    <ShortTermBatchApprovalDialog
      :visible.sync="batchApprovalVisible"
      :type="dialogType"
      :contractorId="form.id"
      @finished="searchList"
    />
    <el-dialog
      :close-on-click-modal="false"
      title="加入黑名单"
      :visible.sync="dialogBlackShow"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form ref="formBlack" label-width="150px" :rules="rulesForm" :model="formBlack">
        <el-form-item label="评价等级" prop="evaluationlevel">
          <el-rate class="!leading-loose" v-model="formBlack.evaluationlevel" show-text> </el-rate>
        </el-form-item>
        <el-form-item label="评价意见" prop="evaluationOpinions">
          <el-input
            v-model="formBlack.evaluationOpinions"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            placeholder="请填写评价意见"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="saveBlackList" :loading="saveLoading"
          >确定</el-button
        >
        <el-button size="small" @click="dialogBlackShow = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { SpecialtyApi } from '@wiz-api/team-management'
import { PeriodContractorApi, PeriodContractorPersonnelApi } from '@wiz-api/contractor-management'
import { EafAccountApi, EafUserApi, EafUserQueryApi } from '@wiz-api/account'
import { FileApi } from '@wiz-api/file-management'
import dayjs from 'dayjs'
import { download } from '@/assets/js/CommonDownload'
import { map, filter, cloneDeep } from 'lodash'
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'
import { unitStatusTypes } from '@/components/safety/enumField/enumTypeMethods'

const specialtyApi = new SpecialtyApi()
const periodContractorApi = new PeriodContractorApi()
const periodContractorPersonnelApi = new PeriodContractorPersonnelApi()
const eafAccountApi = new EafAccountApi()
const eafUserApi = new EafUserApi()
const eafUserQueryApi = new EafUserQueryApi()
const fileApi = new FileApi()
const ApprovalFlowDialog = () => {
  return import('@/components/safety/ApprovalFlow/ApprovalFlowDialog')
}
const ApprovalDialog = () => {
  return import('@/components/safety/ApprovalFlow/ApprovalDialog')
}
const ShortTermContractorPerson = () => {
  return import('./ShortTermContractorPerson')
}
const TableOperateButton = () => {
  return import('@/components/safety/TableOperateButton/TableOperateButton')
}
const ShortTermBatchApprovalDialog = () => {
  return import('../components/ShortTermBatchApprovalDialog')
}

export default {
  components: {
    ApprovalFlowDialog,
    ApprovalDialog,
    ShortTermContractorPerson,
    TableOperateButton,
    ShortTermBatchApprovalDialog,
  },
  data() {
    return {
      search: {
        name: '',
      },
      form: {
        isBlackList: false,
        period: [],
      },
      formBtnLoading: false,
      rules: {
        name: [{ required: true }],
        abbreviation: [{ required: true }],
        leaderName: [{ required: true }],
        phoneNumber: [{ required: true }],
        leaderAccount: [{ required: true }],
        period: [{ required: true }],
        ownerdSpecialtyId: [{ required: true }],
      },
      specialtyList: [],
      tableData: [],
      flowTaskId: null,
      approvalFlowDialog: false,
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      loading: false,
      showPersonForm: false,
      formMode: '',
      formId: '',
      approvalDialog: false,
      approvalLoading: false,
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xlsx', 'xls'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      selection: [],
      batchApprovalVisible: false,
      dialogType: '',
      dialogBlackShow: false,
      rulesForm: {
        evaluationlevel: [
          { required: true, message: '请选择评价等级', trigger: ['blur', 'change'] },
        ],
      },
      formBlack: {
        evaluationOpinions: '',
      },
      saveLoading: false,
      disabledAccount: false,
    }
  },
  computed: {
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    currentUser() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      return userInfo?.profile || {}
    },
    mode() {
      return this.$route.query.mode
    },
    disabledOperation() {
      return ['read', 'approve'].includes(this.mode) || this.form.isBlackList
    },
    updateMode() {
      return ['update'].includes(this.mode)
    },
    canEdit() {
      return ['approve'].includes(this.mode) && this.form.approvalStatus === 2
    },
    titleType() {
      const modeObj = {
        create: '新增',
        update: '编辑',
        read: '查看',
        approve: '查看',
      }
      return `${this.$t(`${modeObj[this.mode]}`)}`
    },
    workFlowStatusTypes() {
      return (val) => {
        let type = ''
        switch (val) {
          case 0:
            type = 'primary'
            break
          case 1:
            type = 'warning'
            break
          case 9:
            type = 'success'
            break
          default:
            type = 'danger'
            break
        }
        return type
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.operate('read', val)
            },
            isShow: true,
          },
          {
            text: '编辑',
            click: () => {
              return this.operate('update', val)
            },
            // 流程状态不为审核中和已完成或者已完成是承包商负责人、非黑名单
            isShow:
              (![1, 9].includes(val.approvalStatus) ||
                (val.approvalStatus === 9 && val.type === 0)) &&
              !val.isBlacklist &&
              !this.disabledOperation,
          },
          {
            text: '删除',
            click: () => {
              return this.deleteData(val)
            },
            // 流程状态不为审核中和已完成，不为承包商负责人
            isShow:
              ![1, 9].includes(val.approvalStatus) && !this.disabledOperation && val.type !== 0,
          },
          {
            text: '提交',
            click: () => {
              return this.operate('submit', val)
            },
            // 待提交、被驳回（只有提交人能再次提交）、已撤回状态和非黑名单下能提交
            isShow:
              ([0, 3].includes(val.approvalStatus) ||
                ([2].includes(val.approvalStatus) && val.taskId)) &&
              !val.isBlacklist &&
              !this.disabledOperation,
          },
          {
            text: '审批',
            click: () => {
              return this.operate('approve', val)
            },
            // 是下一审批人且流程状态为审核中
            isShow:
              val.oprateCode === '001' &&
              [1].includes(val.approvalStatus) &&
              !this.disabledOperation,
          },
          {
            text: '撤回',
            click: () => {
              return this.operate('withdraw', val)
            },
            // 流程状态为审核中
            isShow:
              [1].includes(val.approvalStatus) &&
              !val.isBlacklist &&
              !this.disabledOperation &&
              val.activeRevocation === 1,
          },
          {
            text: '查看流程',
            click: () => {
              return this.handleFlow(val)
            },
            isShow: val.flowTaskId,
          },
          {
            text: '重置密码',
            click: () => {
              return this.resetPassword(val)
            },
            // 流程状态为已完成且非黑名单
            isShow: [9].includes(val.approvalStatus) && !val.isBlacklist && !this.disabledOperation,
          },
          {
            text: '解锁账号',
            click: () => {
              return this.unlockUser(val)
            },
            // 流程状态为已完成且
            isShow: [9].includes(val.approvalStatus) && this.updateMode,
          },
        ]
      }
    },
  },
  methods: {
    async validateLeaderAccount() {
      this.disabledAccount = false
      if (this.form.leaderName && this.form.phoneNumber) {
        const [err, res] = await eafUserQueryApi.getEafUserByNameAndPhone({
          name: this.form.leaderName,
          phone: this.form.phoneNumber,
        })
        if (!err && res) {
          this.$set(this.form, 'leaderAccount', res.userName)
          this.$set(this.form, 'leaderId', res.id)
          this.disabledAccount = true
        }
      }
    },
    operate(type, row) {
      switch (type) {
        case 'create':
          this.showPersonForm = true
          this.formMode = 'create'
          break
        case 'update':
        case 'read':
        case 'approve':
          this.showPersonForm = true
          this.formMode = type
          this.formId = row.id
          break
        case 'submit':
          this.$confirm('是否确认提交当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.loading = true
              let apiRes = []
              if (row.approvalStatus === 2) {
                apiRes = await periodContractorPersonnelApi.approve({
                  body: {
                    id: row.id,
                    isPass: true,
                    approve: '',
                    taskId: row.taskId,
                  },
                })
              } else {
                apiRes = await periodContractorPersonnelApi.submit_0(row.id)
              }
              if (!apiRes[0]) {
                this.$message.success('提交成功！')
                this.findList()
              } else {
                this.loading = false
              }
            })
            .catch(() => {})
          break
        case 'withdraw':
          this.$confirm('是否确认撤回当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.loading = true
              const [err] = await periodContractorPersonnelApi.approve({
                body: {
                  id: row.id,
                  isPass: true,
                  approve: '',
                  taskId: row.flowTaskId,
                  isRevocation: true,
                },
              })
              if (!err) {
                this.$message.success('撤回成功！')
                this.findList()
              } else {
                this.loading = false
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    backToForm() {
      this.showPersonForm = false
      this.searchList()
    },
    deleteData(row) {
      if (row.type === 0) {
        this.$message.warning('不允许删除承包商负责人数据！')
        return
      }
      this.$confirm('是否确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await periodContractorPersonnelApi.callDelete(row.id)
          if (!err) {
            this.$message.success('删除成功！')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    // 重置密码
    async resetPassword(row) {
      this.$confirm('是否确认重置密码？', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await eafAccountApi.clearPasswordToDefault({ body: { userId: row.userId } })
          if (!err) {
            this.$message.success('重置密码成功')
          }
        })
        .catch(() => {})
    },
    async unlockUser(row) {
      const [err] = await eafUserApi.unlockUser({ userId: row.userId })
      if (!err) {
        this.$message.success('账号已成功解锁!')
        this.findList()
      }
    },
    // 查看流程
    handleFlow(row) {
      this.flowTaskId = row.flowTaskId
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.$refs.table && this.$refs.table.clearSelection()
      this.selection = []
      this.loading = true
      const [err, res] = await periodContractorPersonnelApi.pagedListQuery({
        ...this.search,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        contractorId: this.form.id,
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    async getSpecialtyList() {
      const [err, res] = await specialtyApi.getSpecialtyDropDown()
      if (!err) {
        this.specialtyList = res
        this.specialtyList.unshift({ id: '00000000-0000-0000-0000-000000000000', name: '无专业' })
      }
    },
    async getDetail() {
      const [err, res] = await periodContractorApi.getInfo(this.$route.query.id)
      if (!err) {
        this.form = {
          ...res,
          period: [
            dayjs(res.startDate).format('YYYY-MM-DD'),
            dayjs(res.endDate).format('YYYY-MM-DD'),
          ],
        }
        this.validateLeaderAccount()
        this.searchList()
      }
    },
    save(type) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.formBtnLoading = true
          let apiRes = []
          let msgType = ''
          const body = cloneDeep(this.form)
          body.startDate = dayjs(this.form.period[0]).format('YYYY-MM-DD 00:00:00')
          body.endDate = dayjs(this.form.period[1]).format('YYYY-MM-DD 23:59:59')
          if (type === 'submit') {
            msgType = '提交'
            // 驳回调审批接口
            if (this.form.approvalStatus === 2) {
              await periodContractorApi.update(this.form.id, {
                body,
              })
              apiRes = await periodContractorApi[this.form.isDelay ? 'delayApprove' : 'approve']({
                body: {
                  id: this.form.id,
                  isPass: true,
                  approve: '',
                  taskId: this.form.taskId,
                },
              })
            } else {
              apiRes = await periodContractorApi.submit({
                body,
              })
            }
          } else {
            msgType = '编辑'
            apiRes = await periodContractorApi.update(this.form.id, {
              body,
            })
          }
          this.formBtnLoading = false
          if (!apiRes[0]) {
            this.$message.success(`${msgType}成功！`)
            this.$router.go(-1)
          }
        }
      })
    },
    async submitApproval(data) {
      this.approvalLoading = true
      const [err] = await periodContractorApi[this.form.isDelay ? 'delayApprove' : 'approve']({
        body: {
          id: this.form.id,
          isPass: data.isPass,
          approve: data.opinion,
          taskId: this.form.taskId,
        },
      })
      this.approvalLoading = false
      if (!err) {
        this.approvalDialog = false
        this.$message.success('审批成功！')
        this.$router.go(-1)
      }
    },
    // 人员导入
    batchImoport() {
      this.uploadFileProps.active = 0
      this.uploadFileProps.visible = true
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await periodContractorPersonnelApi.importFromExcelTemplateFile()
      if (!err) {
        download('短期承包商人员导入模板.xlsx', res, 'application/octet-stream')
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await periodContractorPersonnelApi.importFromExcelFile({
        file: formData.get('input'),
        contractorId: this.form.id,
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.searchList()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    async exportResults() {
      const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
        returnType: 'Blob',
      })
      if (!err) {
        download(
          '短期承包商人员导入结果.xlsx',
          res,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      }
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    // 导出
    async exportPersonList() {
      if (this.selection.length === 0) {
        this.$message.warning('请选择需要导出的人员数据！')
        return
      }
      const [err, res] = await periodContractorPersonnelApi.exportToExcelFile({
        body: {
          contractorId: this.form.id,
          ids: map(this.selection, 'id'),
        },
      })
      if (!err) {
        download(
          '短期承包商人员导出.xlsx',
          res,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
        this.$message({
          showClose: true,
          message: '下载成功',
          type: 'success',
        })
      }
    },
    // 批量删除
    batchDelete() {
      if (this.selection.length === 0) {
        this.$message.warning('请勾选数据！')
        return
      }
      const filterApproval = this.selection.find((item) => {
        return [1].includes(item.approvalStatus)
      })
      if (filterApproval) {
        this.$message.warning('所选数据包含审核中的数据！')
        return
      }
      const filterStatus = this.selection.find((item) => {
        return [1].includes(item.status)
      })
      if (filterStatus) {
        this.$message.warning('所选数据包含在厂状态的数据！')
        return
      }
      const filterLeader = this.selection.find((item) => {
        return item.type === 0
      })
      if (filterLeader) {
        this.$message.warning('所选数据包含承包商负责人！')
        return
      }
      this.$confirm('是否确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await periodContractorPersonnelApi.deleteMany({
            ids: map(this.selection, 'id'),
          })
          if (!err) {
            this.$message.success('删除成功！')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    openApprovalDialog(type) {
      this.dialogType = type
      this.batchApprovalVisible = true
    },
    setBlack(isBlack) {
      if (this.selection?.length === 0) {
        this.$message.warning('请选择记录')
        return
      }
      if (isBlack) {
        const filterData = filter(this.selection, (item) => {
          return item.isBlacklist
        })
        if (filterData.length > 0) {
          this.$message.warning('请选择非黑名单记录')
          return
        }
        // 加入黑名单
        this.dialogBlackShow = true
        this.$nextTick(() => {
          this.$refs.formBlack.resetFields()
        })
      } else {
        const filterData = filter(this.selection, (item) => {
          return !item.isBlacklist
        })
        if (filterData.length > 0) {
          this.$message.warning('请选择黑名单记录')
          return
        }
        this.$confirm('确认移除黑名单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err] = await periodContractorPersonnelApi.moveOutBlacklist({
              body: map(this.selection, 'id'),
            })
            if (!err) {
              this.$message.success('移除黑名单成功！')
              this.findList()
            }
          })
          .catch(() => {})
      }
    },
    saveBlackList() {
      this.$refs.formBlack.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const [err] = await periodContractorPersonnelApi.moveToBlacklist({
            body: map(this.selection, (item) => {
              return {
                id: item.id,
                appraiseGrade: this.formBlack.evaluationlevel,
                appraiseOpinion: this.formBlack.evaluationOpinions,
              }
            }),
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success('设置黑名单成功！')
            this.dialogBlackShow = false
            this.findList()
          }
        }
      })
    },
  },
  async mounted() {
    clearPlaceholder('.contractor-form')
    await this.getSpecialtyList()
    await this.getDetail()
  },
}
</script>

<style lang="scss" scoped></style>
